<script setup lang="ts">
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { useRouter } from 'vue-router'

const props = defineProps<{
  returnTo?: string
}>()

const router = useRouter()

function goToProfile() {
  if (props.returnTo) {
    router.push({ path: '/profile', query: { returnTo: props.returnTo } })
  } else {
    router.push('/profile')
  }
}
</script>

<template>
  <Alert class="shadow-lg border-primary/20 bg-white" variant="default">
    <AlertTitle>Pension Plan ID Required</AlertTitle>
    <AlertDescription class="mt-2">
      To make contributions to your pension, you need to set up your Irish Life
      Pension Plan ID first.
    </AlertDescription>
    <div class="mt-4 flex justify-end">
      <Button @click="goToProfile"> Set up now </Button>
    </div>
  </Alert>
</template>
